import { qs, qsa, listen } from "@fluorescent/dom";
import { on } from "@/glow/events";

const selectors = {
  wrapper: "[data-truncate-wrapper]",
  content: "[data-truncate-wrapper-content]",
  toggle: "[data-truncate-toggle]",
  accordionContent: ".accordion__content",
};

const classes = {
  disableTruncation: "truncate-wrapper--disabled",
};

export default node => {
  if (!node) return;

  const wrapperEls = qsa(selectors.wrapper, node);

  if (wrapperEls.length < 1) return;

  const events = [];

  const _toggleExpanded = (e, wrapperEl) => {
    const { contentExpanded } = wrapperEl.dataset;

    wrapperEl.dataset.contentExpanded =
      contentExpanded === "true" ? "false" : "true";
  };

  const _toggleTruncation = () => {
    wrapperEls.forEach(wrapperEl => {
      const contentEl = qs(selectors.content, wrapperEl);

      if (contentEl) {
        const contentFit = contentEl.scrollHeight > contentEl.clientHeight;

        wrapperEl.classList.toggle(classes.disableTruncation, !contentFit);
      }
    });
  };

  _toggleTruncation();

  wrapperEls.forEach(el => {
    const wrapperEl = el;
    const toggleEl = qs(selectors.toggle, el);
    const accordionWrapper = el.closest(selectors.accordionContent);

    events.push(listen(toggleEl, "click", e => _toggleExpanded(e, wrapperEl)));

    if (accordionWrapper) {
      accordionWrapper.addEventListener(
        `accordion-opened-${accordionWrapper.id}`,
        () => _toggleTruncation(),
        { once: true }
      );
    }
  });

  events.push(
    on("window:width-changed", () => {
      _toggleTruncation();
    })
  );

  const unload = () => {
    events?.forEach(unsubscribe => unsubscribe());
  };

  return { unload };
};
